import { FC, PropsWithChildren } from 'react';
import { FormProvider, useForm, useFormContext } from 'react-hook-form';
import { isValidEnumValue } from 'utils/tsHelpers';
import { LinkTarget } from '../types';
import { useSelectedHyperlink } from '../../hooks/useSelectedHyperlink';
import { useEditorContext } from '../../contexts/editor';

export type HyperlinkFormState = {
  displayText: string;
  href: string;
  target: LinkTarget;
};

export const HyperlinkFormProvider: FC<PropsWithChildren<unknown>> = ({ children }) => {
  const { editor } = useEditorContext();
  const selectedLink = useSelectedHyperlink();

  const form = useForm<HyperlinkFormState>({
    defaultValues: {
      displayText:
        selectedLink?.textContent ?? editor?.selection.getContent({ format: 'text' }) ?? '',
      href: selectedLink?.getAttribute('href') ?? '',
      target: isValidEnumValue(selectedLink?.target, LinkTarget)
        ? selectedLink?.target
        : LinkTarget.NewWindow,
    },
    mode: 'onSubmit',
    reValidateMode: 'onChange',
  });

  return <FormProvider {...form}>{children}</FormProvider>;
};

export const useHyperlinkFormContext = () => useFormContext<HyperlinkFormState>();
